import { render, staticRenderFns } from "./CAOG1030.vue?vue&type=template&id=19595796&scoped=true"
import script from "./CAOG1030Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAOG1030Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAOG1030.vue?vue&type=style&index=0&id=19595796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19595796",
  null
  
)

export default component.exports